import { get, patch, post } from "api"

export const getSiteMap = async (siteMapId: string) => {
  return get(`/company_admin/site_maps/${siteMapId}`)
}

export const getCustomerSiteMap = async (siteMapId: string) => {
  return get(`/site-maps/${siteMapId}`)
}

interface CustomerType {
  id: string
  name: string
  balance: number
  pastDue: number
}

export interface StorageUnitRowResponse {
  storageUnitRow: {
    align?: "end" | "start" | null
    id: string
    position: { x: number; y: number }
    rotation: number
    storageUnits: Array<{
      dimensions: string
      id: string
      name: string
      typeId: string
    }>
  }
}

export interface UnitType {
  occupancyStatus: "past_due" | "vacant" | "occupied"
  customer?: CustomerType
  price: number
  disabled: boolean
  locked: boolean
  leaseId?: string
  auction: boolean
  cleanOutLeaseId?: string | null
  priceDuration: string
  scheduledMoveIn?: string
  scheduledMoveOut?: string
  lockCode?: string
  lockedAt?: string
  auctionDate?: string
  auctionTime?: string
  tier?: "best" | "better" | "good" | null
}
interface GetSiteMapUnitStatusesResponse {
  achPriceMultiplier?: number
  cardPriceMultiplier?: number
  units: {
    [key: string]: UnitType
  }
}
export const getSiteMapUnitStatuses = async (siteMapId: string) => {
  return get<GetSiteMapUnitStatusesResponse>(`/company_admin/site_maps/${siteMapId}/unit_statuses`)
}

export const getCustomerSiteMapUnitStatuses = async (siteMapId: string) => {
  return get<GetSiteMapUnitStatusesResponse>(`/site-maps/${siteMapId}/unit_statuses`)
}

export const bulkUpdateSiteMapRows = async (
  siteMapId: string,
  rows: Array<{
    id: string
    align?: "end" | "start"
    position?: { x: number; y: number }
    rotation?: number
  }>
) => {
  return patch(`/company_admin/site_maps/${siteMapId}/site_map_storage_unit_rows/bulk_update`, {
    rows,
  })
}

export const addStorageUnitsToRow = async (
  siteMapId: string,
  storageUnitRowId: string,
  storageUnitIds: string[]
) => {
  return post<StorageUnitRowResponse>(
    `/company_admin/site_maps/${siteMapId}/site_map_storage_unit_rows/${storageUnitRowId}/add_storage_units`,
    {
      storage_unit_ids: storageUnitIds,
    }
  )
}

export const bulkDestroySiteMapRows = async (siteMapId: string, rowIds: string[]) => {
  return post(`/company_admin/site_maps/${siteMapId}/site_map_storage_unit_rows/bulk_destroy`, {
    row_ids: rowIds,
  })
}

export const updateSiteMapRow = async (
  siteMapId: string,
  storageUnitRowId: string,
  updates: {
    align?: "end" | "start"
    position?: { x: number; y: number }
    rotation?: number
  }
) => {
  return patch(
    `/company_admin/site_maps/${siteMapId}/site_map_storage_unit_rows/${storageUnitRowId}`,
    {
      align: updates?.align,
      position: updates?.position,
      rotation: updates?.rotation,
    }
  )
}

export const createSiteMapRow = async (siteMapId: string, storageUnitIds: string[]) => {
  return post<StorageUnitRowResponse>(
    `/company_admin/site_maps/${siteMapId}/site_map_storage_unit_rows`,
    {
      storage_unit_ids: storageUnitIds,
    }
  )
}

export const confirmCleanOut = async (leaseId: string) => {
  return patch<{ errors?: string[] }>(
    `/company_admin/leases/${leaseId}/scheduled_lease_auction/lease_auction_sale/confirm_clean_out`
  )
}

export const patchStorageUnit = async (
  storageUnitId: string,
  updates: { disabled?: boolean; locked_out?: boolean }
) => {
  return patch(`/company_admin/storage_units/${storageUnitId}`, {
    storage_unit: updates,
  })
}

export const removeStorageUnitsFromRow = async (
  siteMapId: string,
  storageUnitRowId: string,
  storageUnitIds: string[]
) => {
  return post<StorageUnitRowResponse>(
    `/company_admin/site_maps/${siteMapId}/site_map_storage_unit_rows/${storageUnitRowId}/remove_storage_units`,
    {
      storage_unit_ids: storageUnitIds,
    }
  )
}

export const reorderSiteMapRowStorageUnits = async (
  siteMapId: string,
  storageUnitRowId: string,
  storageUnitIds: string[]
) => {
  return post(
    `/company_admin/site_maps/${siteMapId}/site_map_storage_unit_rows/${storageUnitRowId}/reorder_storage_units`,
    {
      storage_unit_ids: storageUnitIds,
    }
  )
}
